import { render, staticRenderFns } from "./SortableColumnLink.vue?vue&type=template&id=2c849178"
import script from "./SortableColumnLink.vue?vue&type=script&lang=js"
export * from "./SortableColumnLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports